import Button from 'antd/lib/button';
import Model from 'antd/lib/modal';
import Row from 'antd/lib/row';
import React from 'react';

function ViewSparePart({ isOpen, sparePart, handleViewModelCloseClick }) {
  return (
    <div>
      <Model
        open={isOpen}
        onCancel={handleViewModelCloseClick}
        closable={false}
        footer={null}
      >
        <div className='px-8 pb-6'>
          <div className='flex items-center justify-between mb-6'>
            <div className='flex items-center gap-3'>
              <div className='p-2 rounded-lg shadow bg-gradient-to-r from-blue-500 to-purple-600'></div>
              <h2 className='text-2xl font-bold text-text m-0'>
                Spare Part Details
              </h2>
            </div>
          </div>

          <div className='grid grid-cols-1 md:grid-cols-2 gap-4 mb-4'>
            <div className='bg-surface border border-border rounded-lg p-4 shadow-sm md:col-span-2'>
              <div className='text-muted text-xs mb-2'>Image</div>
              <div className='flex items-center gap-3'>
                <img
                  src={sparePart.productImage}
                  alt={`image`}
                  className='w-24 h-24 object-contain border border-border rounded-md bg-white'
                />
              </div>
            </div>

            <div className='bg-surface border border-border rounded-lg p-4 shadow-sm'>
              <div className='text-muted text-xs mb-1'>Model Number</div>
              <div className='text-text font-semibold'>{sparePart.modelNo}</div>
            </div>
            <div className='bg-surface border border-border rounded-lg p-4 shadow-sm'>
              <div className='text-muted text-xs mb-1'>Spare Part Name</div>
              <div className='text-text'>{sparePart.sparePartName}</div>
            </div>
            <div className='bg-surface border border-border rounded-lg p-4 shadow-sm md:col-span-2'>
              <div className='text-muted text-xs mb-1'>Product Name</div>
              <div className='text-text'>{sparePart.productNames}</div>
            </div>
            <div className='bg-surface border border-border rounded-lg p-4 shadow-sm'>
              <div className='text-muted text-xs mb-1'>GST</div>
              <div className='text-text'>{sparePart.gstTax}</div>
            </div>

            <div className='bg-surface border border-border rounded-lg p-4 shadow-sm md:col-span-2'>
              <div className='text-muted text-xs mb-2'>Prices</div>
              <div className='grid grid-cols-2 md:grid-cols-4 gap-3'>
                <div className='bg-bg rounded-md px-3 py-2'>
                  <span className='text-muted text-xs'>P1</span>
                  <div className='text-text font-semibold'>{sparePart.p1}</div>
                </div>
                <div className='bg-bg rounded-md px-3 py-2'>
                  <span className='text-muted text-xs'>P2</span>
                  <div className='text-text font-semibold'>{sparePart.p2}</div>
                </div>
                <div className='bg-bg rounded-md px-3 py-2'>
                  <span className='text-muted text-xs'>P3</span>
                  <div className='text-text font-semibold'>{sparePart.p3}</div>
                </div>
                <div className='bg-bg rounded-md px-3 py-2'>
                  <span className='text-muted text-xs'>R1</span>
                  <div className='text-text font-semibold'>{sparePart.r1}</div>
                </div>
              </div>
            </div>
          </div>

          <div className='flex justify-end gap-3'>
            <Button onClick={handleViewModelCloseClick}>Close</Button>
          </div>
        </div>
      </Model>
    </div>
  );
}

export default ViewSparePart;
